












































import Vue, { PropType } from "vue";
import SelectBoxItem from "@/components/molecules/SelectBoxItem.vue";

const ClickOutside = require("vue-click-outside");

export interface SelectBoxItem {
  id: string;
  name: string;
  image: string;
  imageCropType?: ImageCropType;
  disabled?: boolean;
}

export const ImageCropType = {
  /** 円形 */
  round: "round",
  /** 四角形 */
  rectangle: "rectangle",
} as const;
export type ImageCropType = typeof ImageCropType[keyof typeof ImageCropType];

export default Vue.extend<Data, Methods, Computed, Props>({
  directives: { ClickOutside },
  components: { SelectBoxItem },
  props: {
    items: {
      type: Array as PropType<SelectBoxItem[]>,
      required: true,
    },
    keyAttr: {
      type: String as PropType<string>,
      required: true,
    },
    placeholder: {
      type: String as PropType<string>,
      required: false,
    },
    iconPlaceholder: {
      type: String as PropType<string>,
      required: false,
    },
    selected: Object as PropType<SelectBoxItem>,
    filterMode: Boolean as PropType<boolean>,
    enableUnselected: Boolean as PropType<boolean>,
    grayColor: Boolean as PropType<boolean>,
    disabled: Boolean as PropType<boolean>,
  },
  data() {
    return {
      dataItems: this.$props.items,
      isSelecting: false,
    };
  },
  watch: {
    items() {
      this.dataItems = this.items;
    },
  },
  methods: {
    switchFragment() {
      this.isSelecting = !this.isSelecting;
    },
    close() {
      this.isSelecting = false;
    },
    selectItem(item) {
      this.$emit("select", item);
    },
    unselect() {
      this.$emit("unselect");
    },
  },
});

interface Props {
  items: SelectBoxItem[];
  keyAttr: string;
  placeholder: string;
  iconPlaceholder: string;
  selected: SelectBoxItem;
  filterMode: boolean;
  enableUnselected: boolean;
  grayColor: boolean;
  disabled: boolean;
}

interface Data {
  dataItems: SelectBoxItem[];
  isSelecting: boolean;
}

interface Methods {
  switchFragment(): void;
  close(): void;
  selectItem(item: SelectBoxItem): void;
  unselect(): void;
}

interface Computed {}
